import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { navigate } from "@reach/router";

import { ProjectForm } from "./ProjectForm";
import { addPastProject } from "../../actions/companyActions";
import { getTradeValues } from "actions/companyActions";
import { showToast } from "utils/helpers";
import { handleReadOnly403 } from "utils/executiveReadOnly";
import { useCurrentCompany } from "hooks/auth";

export const AddProject = () => {
	const dispatch = useDispatch();
	const activeCompany = useCurrentCompany();
	const profileTypeId = activeCompany?.profile_type?.id;

	const initialValues = {
		company_id: activeCompany.id,
		name: "",
		location: "",
		summary: "",
		value: profileTypeId === 3 ? "0" : "",
		year_completed: "",
		funding_type: "",
		site_area: "",
		gross_floor_area: "",
		client_name: "",
		head_contractor: "",
		sector_id: "",
		scope: [],
		images: [],
		innovation_value_summary: "",
		awards: "",
		testimonials: "",
		testimonialFile: {},
		status: "",
		procurement_method_ids: [],
		trade_ids: [],
		trade_value: "",
		disciplines: [{ expertise: "", disciplines: [] }],
	};
	const [errorStatus, setErrorStatus] = useState(false);

	useEffect(() => {
		dispatch(getTradeValues());
	}, [dispatch]);
	const handleSubmit = async (values, { setErrors }) => {
		try {
			const result = await dispatch(addPastProject(values));
			const projectId = result?.data?.id || "new";
			navigate("../projects");
			const toastId = `project_add_${projectId}`;
			showToast("Project added successfully.", "Success", true, toastId);
		} catch (e) {
			const error = await e.response.json();
			// Read-only 403 already surfaced its own warning toast centrally;
			// skip the generic error toast and field errors so they don't stack.
			if (handleReadOnly403(error)) {
				return;
			}
			setErrors(error.errors);
			setErrorStatus(true);
			const toastId = `project_add_error`;
			showToast(error.message, "Error", false, toastId);
		}
	};

	return (
		<ProjectForm
			initialValues={initialValues}
			handleSubmit={handleSubmit}
			profileTypeId={profileTypeId}
			errorStatus={errorStatus}
			setErrorStatus={setErrorStatus}
		/>
	);
};
